module.exports = __webpack_public_path__ + "static/media/multimedia.2a663543.png";